import { useEffect } from 'react';

/**
 * Schließt ein Dropdown bei Klick außerhalb oder Escape-Taste.
 * Ersetzt die in vielen Komponenten duplizierten useEffect-Paare.
 *
 * @param {boolean} isOpen - Ob das Dropdown geöffnet ist
 * @param {function} close - Funktion zum Schließen des Dropdowns
 * @param {string} [containerSelector] - CSS-Selektor des Dropdown-Containers (für closest()-Check)
 */
export function useDropdownClose(isOpen, close, containerSelector = '.sort-wrapper') {
  useEffect(() => {
    if (!isOpen) return;

    function handleClickOutside(e) {
      if (!e.target.closest(containerSelector)) {
        close();
      }
    }

    function handleEscape(e) {
      if (e.key === 'Escape') {
        close();
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('keydown', handleEscape);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('keydown', handleEscape);
    };
  }, [isOpen, close, containerSelector]);
}
